import type { FC, PropsWithChildren } from 'react';
import { Button, Card, Container, Nav, Navbar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@furality/frontend-stack';
import LanguageChangerDropdown from '@/components/LanguageChangerDropdown.tsx';
import type TranslationKey from '@/lib/i18n/TranslationKey.ts';
import useTitle from '@/lib/useTitle.ts';

type CardLayoutProps = {
  title: TranslationKey;
};
const CardLayout: FC<PropsWithChildren<CardLayoutProps>> = ({ children, title }) => {
  const auth = useAuth();
  const { t } = useTranslation();

  useTitle(title);

  return (
    <div
      className="main-background"
      style={{
        height: '100lvh',
        overflowY: 'auto',
      }}
    >
      <section className="min-vh-100 d-flex align-items-center no-background py-4">
        <header className="header header-transparent" style={{ zIndex: 1000 }}>
          <Navbar className="furality-navbar bg-none" style={{ '--nav-height': 'auto' }}>
            <Container className="px-lg-0">
              <Card className="ms-auto p-2 rounded-0 rounded-bottom-4">
                <Nav className="gap-2">
                  <LanguageChangerDropdown />
                  {auth.state === 'loggedIn' && (
                    <Button onClick={() => auth.logout()} size="sm" variant="danger">
                      {t('logout')}
                    </Button>
                  )}
                </Nav>
              </Card>
            </Container>
          </Navbar>
        </header>
        <div className="container-fluid">
          {/* The margin-top-5 on mobile helps the card not overlap the language dropdown */}
          <Card
            style={{ maxWidth: '45em' }}
            className="center mt-5 mt-md-0 mb-0 p-3 px-lg-6 bg-body border-0"
          >
            {children}
          </Card>
        </div>
      </section>
    </div>
  );
};

export default CardLayout;
